import React from 'react';
import { forwardRef } from 'react';
import { StyledFormMessage, StyledInner, StyledSearchIcon, StyledButtonIcon, StyledInput, StyledButtonContainer, StyledButton, StyledLabel, StyledOuter } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const SearchField = forwardRef(({ className, onChange, onClick, onKeyDown, clearButton, value, id, label, hint, disabled, autoComplete, inputRef, additionalIconButton, readOnly, margin, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const hasValue = Boolean(value);
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledOuter, { className: className, ref: ref, margin: margin, ...pickDataProps(rest) },
        React.createElement(StyledInner, null,
            React.createElement(StyledSearchIcon, { name: "search", size: "s" }),
            React.createElement(StyledInput, { id: id, type: "search", disabled: disabled, readOnly: readOnly, onChange: onChange, onKeyDown: onKeyDown, onClick: onClick, autoComplete: autoComplete, ref: inputRef, value: value, additionalButton: Boolean(additionalIconButton), hasValue: hasValue, ...pickA11yProps(rest), "aria-describedby": ariaDescribedBy }),
            React.createElement(StyledLabel, { hasValue: hasValue, htmlFor: id }, label),
            (value || additionalIconButton) && (React.createElement(StyledButtonContainer, null,
                value && (React.createElement(StyledButton, { onClick: clearButton.onClick, "aria-label": clearButton['aria-label'] },
                    React.createElement(StyledButtonIcon, { name: "cancel", size: "s" }))),
                additionalIconButton && (React.createElement(StyledButton, { "aria-label": additionalIconButton['aria-label'], onClick: additionalIconButton.onClick },
                    React.createElement(StyledButtonIcon, { name: additionalIconButton.icon, size: "s" })))))),
        hint && React.createElement(StyledFormMessage, { variant: "hint", text: hint, id: hintId })));
});
SearchField.displayName = 'SearchField';
//# sourceMappingURL=index.js.map